import { render, staticRenderFns } from "./labelInfo.vue?vue&type=template&id=869b7bb6&scoped=true&"
import script from "./labelInfo.vue?vue&type=script&lang=js&"
export * from "./labelInfo.vue?vue&type=script&lang=js&"
import style0 from "./labelInfo.vue?vue&type=style&index=0&id=869b7bb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869b7bb6",
  null
  
)

export default component.exports